import { createSvgIcon } from '@mui/material';

const HotelSvg = createSvgIcon(
  <svg width='75' height='80' viewBox='0 0 75 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M40.9833 10.638L59.8516 15.6566C66.8059 17.5063 69.6044 22.5141 67.7645 29.3301L61.5331 52.4152C60.3343 56.8561 57.8815 59.6249 54.4432 60.5532C54.5784 59.6233 54.6478 58.6545 54.6478 57.6507V35.9027C54.6478 26.4794 48.5605 20.144 39.4697 20.144H26.811L27.2409 18.5517C29.0807 11.7357 34.1393 8.81768 40.9833 10.638Z'
      fill='#EFF4FB'
    />
    <path
      d='M16.0903 20.3057H39.3402C43.7541 20.3057 47.4005 21.8407 49.9444 24.4836C52.49 27.1285 53.9716 30.9249 53.9716 35.5175V57.2655C53.9716 61.8444 52.4902 65.6342 49.9446 68.2758C47.4007 70.9157 43.7541 72.4507 39.3402 72.4507H16.0903C11.6763 72.4507 8.02272 70.9156 5.47201 68.2753C2.91971 65.6335 1.43213 61.8438 1.43213 57.2655V35.5175C1.43213 30.9255 2.91996 27.1292 5.47224 24.4841C8.02288 21.8408 11.6763 20.3057 16.0903 20.3057Z'
      fill='white'
      fillOpacity='0.35'
      stroke='url(#paint0_linear_1722_50161)'
      strokeWidth='1.09375'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <g opacity='0.5' filter='url(#filter0_f_1722_50161)'>
      <path
        d='M54.6621 59.4383C54.7369 58.7343 54.7751 58.0095 54.7751 57.2655V35.5175C54.7751 26.0942 48.6877 19.7588 39.5969 19.7588H27.2055L21.5234 40.8087C19.6778 47.6459 22.5746 52.5296 29.3292 54.3262L47.9508 59.2791C50.4762 59.9508 52.73 59.9934 54.6621 59.4383Z'
        fill='#1C559C'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.2721 35.4298C19.2721 34.6318 19.919 33.985 20.7169 33.985H36.7203C37.5182 33.985 38.1651 34.6318 38.1651 35.4298V56.7677C38.1651 57.5656 37.5182 58.2124 36.7203 58.2124H32.6084V52.6506C33.0165 52.6874 33.4336 52.5183 33.6975 52.1665C34.1026 51.6264 33.9931 50.8601 33.453 50.455C32.0872 49.4306 30.4259 48.8769 28.7186 48.8769C27.0114 48.8769 25.3501 49.4306 23.9843 50.455C23.4442 50.8601 23.3347 51.6264 23.7398 52.1665C24.0037 52.5183 24.4208 52.6874 24.8288 52.6506V58.2124H20.7169C19.919 58.2124 19.2721 57.5656 19.2721 56.7677V35.4298ZM26.014 60.6574C26.0264 60.6578 26.0388 60.658 26.0513 60.658C26.0638 60.658 26.0762 60.6578 26.0886 60.6574H31.3486C31.361 60.6578 31.3735 60.658 31.3859 60.658C31.3984 60.658 31.4109 60.6578 31.4233 60.6574H36.7203C38.8685 60.6574 40.61 58.9159 40.61 56.7677V35.4298C40.61 33.2815 38.8685 31.54 36.7203 31.54H20.7169C18.5686 31.54 16.8271 33.2815 16.8271 35.4298V56.7677C16.8271 58.9159 18.5686 60.6574 20.7169 60.6574H26.014ZM30.1635 58.2124H27.2738V51.517C27.7416 51.3883 28.2273 51.3219 28.7186 51.3219C29.2099 51.3219 29.6957 51.3883 30.1635 51.517V58.2124ZM27.4958 39.4313C27.4958 38.7561 28.0432 38.2088 28.7183 38.2088H28.7319C29.4071 38.2088 29.9544 38.7561 29.9544 39.4313C29.9544 40.1064 29.4071 40.6538 28.7319 40.6538H28.7183C28.0432 40.6538 27.4958 40.1064 27.4958 39.4313ZM28.7183 43.5428C28.0432 43.5428 27.4958 44.0902 27.4958 44.7653C27.4958 45.4405 28.0432 45.9878 28.7183 45.9878H28.7319C29.4071 45.9878 29.9544 45.4405 29.9544 44.7653C29.9544 44.0902 29.4071 43.5428 28.7319 43.5428H28.7183ZM34.053 43.5428C33.3778 43.5428 32.8305 44.0902 32.8305 44.7653C32.8305 45.4405 33.3778 45.9878 34.053 45.9878H34.0665C34.7417 45.9878 35.289 45.4405 35.289 44.7653C35.289 44.0902 34.7417 43.5428 34.0665 43.5428H34.053ZM32.8305 39.4313C32.8305 38.7561 33.3778 38.2088 34.053 38.2088H34.0665C34.7417 38.2088 35.289 38.7561 35.289 39.4313C35.289 40.1064 34.7417 40.6538 34.0665 40.6538H34.053C33.3778 40.6538 32.8305 40.1064 32.8305 39.4313ZM23.3837 43.5428C22.7085 43.5428 22.1612 44.0902 22.1612 44.7653C22.1612 45.4405 22.7085 45.9878 23.3837 45.9878H23.3973C24.0724 45.9878 24.6197 45.4405 24.6197 44.7653C24.6197 44.0902 24.0724 43.5428 23.3973 43.5428H23.3837ZM22.1612 39.4313C22.1612 38.7561 22.7085 38.2088 23.3837 38.2088H23.3973C24.0724 38.2088 24.6197 38.7561 24.6197 39.4313C24.6197 40.1064 24.0724 40.6538 23.3973 40.6538H23.3837C22.7085 40.6538 22.1612 40.1064 22.1612 39.4313Z'
      fill='url(#paint1_linear_1722_50161)'
    />
    <defs>
      <filter
        id='filter0_f_1722_50161'
        x='1.29053'
        y='0.0712891'
        width='73.1719'
        height='79.4385'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='9.84375' result='effect1_foregroundBlur_1722_50161' />
      </filter>
      <linearGradient
        id='paint0_linear_1722_50161'
        x1='9.42278'
        y1='25.9612'
        x2='43.3298'
        y2='68.2669'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' stopOpacity='0.25' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1722_50161'
        x1='38.9238'
        y1='36.7982'
        x2='12.4226'
        y2='37.5039'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </svg>,
  'HotelSvg',
);

export default HotelSvg;
